import React from 'react';
import Image from 'next/image';
import styles from './design-brand-book.module.css';
import { Button, Container } from '../../components';

export default function BrandBook() {
  return (
    <div className={styles.root}>
      <Container>
        <div className={styles.wrapper}>
          <Button tag="a" href="#form" appearance="design">
            Request the brandbook
          </Button>
          <h3 className={styles.title}>The logo creation</h3>
          <h6 className={styles.text}>When the new brand comes to life.</h6>
        </div>
      </Container>
      <div className={styles.image}>
        <Image
          alt="concept logo"
          width={1920}
          height={477}
          src="/design/brand/d-banner.jpg"
        />
      </div>
    </div>
  );
}
